export let routes = [
  {
    path: '/x3-side-campus',
    name: 'x3-side-campus',
    component: () => import('@x3/js/side/campus/campus.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsCampus(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-campus',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
